export default __webpack_public_path__ + "static/media/divider-plane.c86ee6ca.svg";